var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"h5 text-uppercase mb-4"},[_vm._v("Related products")]),_c('div',{staticClass:"row"},_vm._l((_vm.Products),function(product){return _c('div',{key:product.id,staticClass:"col-lg-3 col-sm-6"},[_c('Product',{attrs:{"product":product}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }